import { useContext } from 'react'

import { AIAssistantContext } from '../providers/AIAssistantProvider'

export const useAIAssistant = () => {
  const { showAIAssistant, setShowAIAssistant, isSalesforceWidgetInitialized } =
    useContext(AIAssistantContext)

  const handleOpenAssistant = () => {
    if (
      isSalesforceWidgetInitialized &&
      window.embeddedservice_bootstrap?.utilAPI?.launchChat
    ) {
      window.embeddedservice_bootstrap?.utilAPI?.launchChat()
    } else {
      setShowAIAssistant(true)
    }
  }

  return { showAIAssistant, setShowAIAssistant, handleOpenAssistant }
}
